module.exports = __webpack_public_path__ + "assets/img/footer-blob-top-right.7f8794ea.png";